const feature = 'stats';

export enum ReportCacheKeys {
  EMPLOYEE_REPORTS = `${feature}-employee-reports`,
  ADMIN_REPORTS = `${feature}-admin-reports`,
  FACILITY_EMPLOYEES_AGGREGATES = `${feature}-facility-employees-aggregates`,
  FACILITY_AGGREGATES = `${feature}-facility-aggregates`,
}

export enum MetricCacheKeys {
  EMPLOYEE_METRIC = `${feature}-employee-metrics`,
  ADMIN_API_METRIC = `${feature}-admin-api-metrics`,
}

export enum FacilityCacheKeys {
  FACILITY_MANAGER_API_METRIC = `${feature}-facility-manager-api-metrics`,
}
